module.exports = __webpack_public_path__ + "img/4-门窗.67f6b0fb.jpg";